import React, { useMemo, useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";

const PHONE = "+91 99999 99999"; // ✅ replace
const EMAIL = "contact@yourcafirm.in"; // ✅ replace
const ADDRESS = "Office Address: New Delhi, India"; // ✅ replace
const WHATSAPP_NUMBER = "919999999999"; // ✅ replace

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    service: "GST Registration & Filing",
    message: ""
  });

  const services = useMemo(
    () => [
      "GST Registration & Filing",
      "Income Tax Return (ITR) Filing",
      "Company & Startup Registration",
      "Audit & Assurance",
      "ROC & Compliance",
      "Accounting & Bookkeeping"
    ],
    []
  );

  const onChange = (e) => setForm((s) => ({ ...s, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();

    const text = encodeURIComponent(
      `Hi, I want a CA consultation.

Name: ${form.name}
Phone: ${form.phone}
Email: ${form.email}
Service: ${form.service}
Message: ${form.message}`
    );

    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${text}`, "_blank", "noreferrer");
  };

  return (
    <section id="contact" className="section">
      <div className="mx-auto max-w-7xl container-pad">
        <h2 className="section-title">Contact</h2>
        <p className="section-subtitle">
          Share your details and we’ll get back with the right checklist and next steps. For fastest response, use WhatsApp.
        </p>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {/* Form */}
          <div className="card p-6 lg:col-span-2">
            <form onSubmit={onSubmit} className="grid gap-4">
              <div className="grid gap-4 sm:grid-cols-2">
                <div>
                  <label className="text-sm font-medium text-navy-900">Name</label>
                  <input
                    name="name"
                    value={form.name}
                    onChange={onChange}
                    required
                    placeholder="Your full name"
                    className="mt-2 w-full rounded-xl border border-navy-900/15 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-navy-200"
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-navy-900">Phone (WhatsApp preferred)</label>
                  <input
                    name="phone"
                    value={form.phone}
                    onChange={onChange}
                    required
                    placeholder="+91 98xxxxxxx"
                    className="mt-2 w-full rounded-xl border border-navy-900/15 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-navy-200"
                  />
                </div>
              </div>

              <div className="grid gap-4 sm:grid-cols-2">
                <div>
                  <label className="text-sm font-medium text-navy-900">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={onChange}
                    placeholder="you@example.com"
                    className="mt-2 w-full rounded-xl border border-navy-900/15 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-navy-200"
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-navy-900">Service</label>
                  <select
                    name="service"
                    value={form.service}
                    onChange={onChange}
                    className="mt-2 w-full rounded-xl border border-navy-900/15 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-navy-200"
                  >
                    {services.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-navy-900">Message</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  rows={5}
                  placeholder="Tell us what you need (GST filing, ITR, registration, compliance, etc.)"
                  className="mt-2 w-full rounded-xl border border-navy-900/15 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-navy-200"
                />
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <button type="submit" className="btn-primary">
                  <FaWhatsapp /> Submit on WhatsApp
                </button>
                <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="btn-secondary">
                  <FaPhoneAlt /> Call Now
                </a>
                <a href={`mailto:${EMAIL}`} className="btn-secondary">
                  <FaEnvelope /> Email
                </a>
              </div>

              <p className="text-xs text-navy-800/60">
                By submitting, you agree to be contacted regarding your query. We do not share your information with third parties.
              </p>
            </form>
          </div>

          {/* Contact info */}
          <div className="space-y-6">
            <div className="card p-6">
              <div className="font-heading text-lg text-navy-900">Quick Contact</div>
              <div className="mt-4 space-y-3 text-sm text-navy-800/80">
                <div className="flex items-start gap-3">
                  <FaPhoneAlt className="mt-0.5 text-navy-900" />
                  <div>
                    <div className="font-medium text-navy-900">Phone</div>
                    <a className="link" href={`tel:${PHONE.replace(/\s/g, "")}`}>{PHONE}</a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaWhatsapp className="mt-0.5 text-emeraldBrand-600" />
                  <div>
                    <div className="font-medium text-navy-900">WhatsApp</div>
                    <a className="link" href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer">
                      Chat on WhatsApp
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaEnvelope className="mt-0.5 text-navy-900" />
                  <div>
                    <div className="font-medium text-navy-900">Email</div>
                    <a className="link" href={`mailto:${EMAIL}`}>{EMAIL}</a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaMapMarkerAlt className="mt-0.5 text-navy-900" />
                  <div>
                    <div className="font-medium text-navy-900">Office</div>
                    <div className="text-sm text-navy-800/80">{ADDRESS}</div>
                  </div>
                </div>
              </div>

              <div className="mt-5 rounded-2xl bg-navy-50 p-4 border border-navy-900/5">
                <div className="font-medium text-navy-900">Business hours</div>
                <div className="text-sm text-navy-800/75">Mon–Sat: 10:00 AM – 7:00 PM</div>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="p-4 border-b border-navy-900/10">
                <div className="font-heading text-lg text-navy-900">Find us on Maps</div>
                <div className="text-sm text-navy-800/70">Update the location embed as per your office.</div>
              </div>
              <div className="h-64">
                {/* Replace query with your office location */}
                <iframe
                  title="Google Map"
                  className="h-full w-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps?q=New%20Delhi%20India&output=embed"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
